import "../css/style.scss";

// Modules and Classes

import JuryCarousel from "./modules/JuryCarousel";
import SponsorsCarousel from "./modules/SponsorsCarousel";
import AnimationsController from "./modules/AnimationsController";
import SendEmailInscription from "./modules/EmailHandler";
import DateFilterController from "./modules/DateFilterController";
import TextAnimationController from "./modules/TextAnimationController";
import PageHipHopAnimationController from "./modules/PageHipHopAnimationController";
import MobileFilterController from "./modules/MobileFilterController";
import MenuController from "./modules/MenuController";
import ProgressBarController from "./modules/ProgressBarController";

// Instatiate a new object using modules/classes

if (
  window.location.pathname == "/" ||
  window.location.pathname == "/en/home-page-en/"
) {
  let jurycarousel = new JuryCarousel();
  let animationscontroller = new AnimationsController();

  document.addEventListener("DOMContentLoaded", function () {
    const iframe = document.getElementById("spline-iframe");
    const spinner = document.getElementById("spinner");

    // Fallback: Hide spinner after 2 seconds, even if the iframe hasn't fully loaded
    const fallbackTimeout = setTimeout(() => {
      spinner.style.display = "none"; // Hide spinner
      iframe.style.visibility = "visible"; // Show iframe
    }, 2000); // 2 seconds

    // Hide spinner and clear fallback if the iframe loads first
    iframe.addEventListener("load", function () {
      clearTimeout(fallbackTimeout); // Cancel the fallback timeout
      spinner.style.display = "none"; // Hide spinner
      iframe.style.visibility = "visible"; // Show iframe
    });
  });
}

if (
  window.location.pathname == "/hip-hop-dance-week/" ||
  window.location.pathname == "/hip-hop-dance-week" ||
  window.location.pathname == "/en/hip-hop-dance-week-en" ||
  window.location.pathname == "/en/hip-hop-dance-week-en/"
) {
  let datefiltercontroller = new DateFilterController();
  let mobilefiltercontroller = new MobileFilterController();
}

if (
  window.location.pathname == "/last-chance-preselection/" ||
  window.location.pathname == "/last-chance-preselection" ||
  window.location.pathname == "/en/last-chance-preselection-en" ||
  window.location.pathname == "/en/last-chance-preselection-en/"
) {
  let pagehiphopanimationcontroller = new PageHipHopAnimationController();
}

let sponsorscarousel = new SponsorsCarousel();
let sendemailinscription = new SendEmailInscription();
let textanimationcontroller = new TextAnimationController();
let menucontroller = new MenuController();
let progressbarcontroller = new ProgressBarController();

window.addEventListener("DOMContentLoaded", () => {
  document.querySelector(".lang-attribute").innerHTML =
    Cookies.get("pll_language");
});

document.addEventListener("DOMContentLoaded", function () {
  const accordionItems = document.querySelectorAll(".accordion-item");

  accordionItems.forEach((item) => {
    const accordionHeader = item.querySelector(".accordion-header");
    const chevronRight = accordionHeader.querySelector(
      ".accordion-header__chevron-right"
    );
    const chevronDown = accordionHeader.querySelector(
      ".accordion-header__chevron-down"
    );

    accordionHeader.addEventListener("click", function () {
      item.classList.toggle("active");
      if (item.classList.contains("active")) {
        chevronRight.style.display = "none";
        chevronDown.style.display = "inline-block";
      } else {
        chevronRight.style.display = "inline-block";
        chevronDown.style.display = "none";
      }
    });
  });
});
